import styles from './tooltips.module.css';
import { Popover, OverlayTrigger, PopoverContent } from 'react-bootstrap';
import blankCheckbox from '../../images/red-circle-cross.png';
import checkbox from '../../images/green-circle-tick.png';

const tooltips = {
  route: (
    <OverlayTrigger
      placement="right"
      trigger={['hover', 'focus']}
      overlay={
        <Popover style={{ minWidth: '15rem' }}>
          <PopoverContent>
            <h6>Route</h6>
            <p>A route is required before you can begin the process of entering a New Load.</p>
          </PopoverContent>
        </Popover>
      }
    >
      <div className="important-info"></div>
    </OverlayTrigger>
  ),
  officeOfDestination: (
    <OverlayTrigger
      placement="right"
      trigger={['hover', 'focus']}
      overlay={
        <Popover style={{ minWidth: '35rem' }}>
          <PopoverContent>
            <h6>Common Transit Procedure</h6>
            <p>
              Common transit is a customs procedure that facilitates the movement of goods to, from, through or between
              the countries that have signed the Common Transit Convention. This includes movements to, from, through or
              between all EU member states.
            </p>
            <h6>Union Transit Procedure</h6>
            <p>
              Union transit is a customs procedure that allows goods not in free circulation in the EU, to move within
              the EU, while customs duties or other charges are suspended. This may apply to goods moving to, from or
              through Northern Ireland.
            </p>
            <p>
              It also allows goods that are in free circulation in the EU to move from a point of departure in the EU,
              to point of destination in the EU, through the territory of a third country, such as Great Britain
              (England, Wales and Scotland). This may apply to goods moving to and from Northern Ireland.
            </p>
            <p>
              <i>To find out more, click the icon.</i>
            </p>
          </PopoverContent>
        </Popover>
      }
    >
      <a
        target="_blank"
        href="https://ec.europa.eu/taxation_customs/dds2/col/col_consultation_location.jsp?Lang=en"
        rel="noreferrer"
      >
        <div className={styles.infoIcon}></div>
      </a>
    </OverlayTrigger>
  ),
  portModal: (
    <OverlayTrigger
      placement="top"
      trigger={['hover', 'focus']}
      overlay={
        <Popover style={{ minWidth: '50rem' }}>
          <PopoverContent>
            <h5>Port Model</h5>
            <p></p>
            <p>
              <b>
                There are two models for customs control in operation at UK ports and border locations in use today:
              </b>
            </p>
            <p></p>
            <p>
              <b>GVMS</b> - Goods must have a customs procedure associated to them. This can be a pre-lodged entry,
              transit document or entry in declarants records (EIDR) or another customs procedure. This must be then
              added to the GMR via GVMS otherwise the consignment or vehicle will not be allowed to board the vessel or
              train.
            </p>
            <p>
              <b>Temporary storage (Inventory Linked)</b> - Goods will be entered into a port or border locations
              inventory system – The goods must be claimed by a nominated agent in order to release them into a customs
              procedure such as an import declaration or transit.
            </p>

            <p></p>
            <p>
              Most GB ports operate a mixed model and offer both GVMS or Temporary storage (Inventory Linked) as methods
              of customs control. If the port is a hybrid and offers a choice, based upon the accompanied status of the
              consignment we have assumed the model for you. However the choice between GVMS and Temporary storage
              (Inventory Linked) can be made by a carrier or haulier, please check before selecting the model you wish
              to use.
            </p>
            <p></p>
          </PopoverContent>
        </Popover>
      }
    >
      <div className="important-info"></div>
    </OverlayTrigger>
  ),
  consignor: (blocked, standingAuthority, clientIdAllowSAonNeeNors) => (
    <div className="d-flex flex-row align-items-center">
      <OverlayTrigger
        placement="right"
        trigger={['hover', 'focus']}
        overlay={
          <Popover className={styles.neenorPopover}>
            <PopoverContent>
              <h6>Consignors – Consignees</h6>

              <p>
                In a consignment process, it encompasses the sending of goods from a consignor to a consignee. The
                person who ships the goods is the consignor (exporter), while the receiver is the consignee (importer).
              </p>
              <h6>Details Legend</h6>
              <p className={styles.legendItem}>
                <img src={checkbox} alt="complete" className={styles.legendIcon} />
                Valid details: Standing authority, Complete address and Valid DB status.
              </p>

              <p className={styles.legendItem}>
                <img src={blankCheckbox} alt="incomplete" className={styles.legendIcon} />
                Incomplete details: Missing standing authority, address, or invalid DB status.
              </p>
            </PopoverContent>
          </Popover>
        }
      >
        <div className={styles.infoIcon}></div>
      </OverlayTrigger>

      <img
        src={blocked ? blankCheckbox : standingAuthority || clientIdAllowSAonNeeNors ? checkbox : blankCheckbox}
        alt=""
        className={styles.statusIcon}
      />
    </div>
  ),
  consignee: (blocked, standingAuthority, clientIdAllowSAonNeeNors) =>
    blocked ? (
      <img src={blankCheckbox} alt="" width="15px" height="15px" />
    ) : standingAuthority || clientIdAllowSAonNeeNors ? (
      <img src={checkbox} alt="" width="15px" height="15px" />
    ) : (
      <img src={blankCheckbox} alt=" " width="15px" height="15px" />
    ),
  shippingStatus: (
    <OverlayTrigger
      placement="top"
      trigger={['hover', 'focus']}
      overlay={
        <Popover>
          <PopoverContent>
            <h6>Accompanied</h6>
            <p>The driver travels with the shipment.</p>
            <h6>Unaccompanied</h6>
            <p>The shipment travels alone.</p>
          </PopoverContent>
        </Popover>
      }
    >
      <div className={styles.infoIcon}></div>
    </OverlayTrigger>
  ),
  container: (
    <OverlayTrigger
      placement="top"
      trigger={['hover', 'focus']}
      overlay={
        <Popover style={{ minWidth: '30rem' }}>
          <PopoverContent>
            <h6>Container</h6>
            <p>Please provide your container number if known and arriving via Lo/Lo or Lift-on/Lift-off. </p>
            <p>
              If your container is arriving Ro/Ro or Roll-on/Roll-off on a skeletal trailer then you do not need to
              provide this.
            </p>
          </PopoverContent>
        </Popover>
      }
    >
      <div className={styles.infoIcon}></div>
    </OverlayTrigger>
  ),
  incoterm: (
    <OverlayTrigger
      placement="top"
      trigger={['hover', 'focus']}
      overlay={
        <Popover style={{ minWidth: '30rem' }}>
          <PopoverContent>
            <h6>Incoterms</h6>
            <p>
              A set of internationally recognised rules which define the responsibilities of sellers and buyers.
              Incoterms specifies who is responsible for paying for and managing the shipment, insurance, documentation,
              customs clearance, and other logistical activities.
            </p>
          </PopoverContent>
        </Popover>
      }
    >
      <div className={styles.infoIcon}></div>
    </OverlayTrigger>
  ),
  adjustments: (isAdjustmentsRequired) => (
    <OverlayTrigger
      placement="top"
      trigger={['hover', 'focus']}
      overlay={
        <Popover style={{ minWidth: '15rem' }}>
          <PopoverContent>
            {isAdjustmentsRequired ? (
              <>
                <h6>Adjustments</h6>
                <p>Freight Charges is mandatory for this Incoterm.</p>
              </>
            ) : (
              <>
                <h6>Adjustments</h6>
                <p>Adjustments are optional for this Incoterm.</p>
              </>
            )}
          </PopoverContent>
        </Popover>
      }
    >
      <div className={styles.infoIcon} style={{ marginBottom: '-5px' }}></div>
    </OverlayTrigger>
  ),
};

export default tooltips;
